import { ApiService } from "services/ApiService";
import { ApiUrl } from "services/ApiUrl";

const URL_API = ApiUrl.BASE;

const HijosService = {

  async obtenerHijosProximosLimite({ mesesAnticipacion = 12, tipo = null }) {
    const respuesta = await ApiService(URL_API).get("/derecho-habiente/hijos-proximos-limite", {
      params: {
        mesesAnticipacion,
        ...(tipo && { tipo })
      }
    });
    return respuesta.data;
  },

  async obtenerTodosLosHijos() {
    const respuesta = await ApiService(URL_API).get("/derecho-habiente/hijos-todos");
    return respuesta.data;
  },

  async obtenerEstadisticas() {
    const respuesta = await ApiService(URL_API).get("/derecho-habiente/estadisticas");
    return respuesta.data;
  },

  async moverHijoAEstudioSuperior(data) {
    const respuesta = await ApiService(URL_API).post("/derecho-habiente/mover-estudio-superior", data);
    return respuesta.data;
  },

  async obtenerReporteAsignacionFamiliar() {
    const respuesta = await ApiService(URL_API).get("/derecho-habiente/reporte-asignacion-familiar");
    return respuesta.data;
  },

  async agregarHijo(data) {
    const respuesta = await ApiService(URL_API).post("/derecho-habiente/agregar-hijo", data);
    return respuesta.data;
  },

  async descargarExcelAsignacionFamiliar() {
    const respuesta = await ApiService(URL_API).get("/derecho-habiente/reporte-asignacion-familiar/excel", {
      responseType: 'blob'
    });
    return respuesta.data;
  }

};

export { HijosService };